import { render, staticRenderFns } from "./PageMasthead.vue?vue&type=template&id=81e484e2"
import script from "./PageMasthead.vue?vue&type=script&lang=js"
export * from "./PageMasthead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports